var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs"},[_vm._v("\n  ZONE - "),_c('span',{staticStyle:{"font-weight":"bold","color":"#202f64"}},[_vm._v("Budynki")])])}]

export { render, staticRenderFns }